function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
import arrayEntry from '../fragments/arrayEntry.js';
import simpleBlockContent from '../fragments/simpleBlockContent.js';
import simpleCardsListSectionCard from './simpleCardsListSectionCard.js';
import labeledCallToAction from './labeledCallToAction.js';
var schema = defineObject('simpleCardsListSection', {
    title: {
        title: 'Title',
        type: 'string'
    },
    description: _object_spread({
        title: 'Description'
    }, simpleBlockContent.fragment),
    rows: {
        title: 'Rows',
        type: 'array',
        of: [
            {
                type: 'simpleCardsListSectionCard'
            }
        ]
    },
    actions: {
        title: 'Actions',
        type: 'array',
        of: [
            {
                type: 'labeledCallToAction'
            }
        ],
        validation: function validation(Rule) {
            return Rule.max(2);
        }
    }
}, [
    simpleCardsListSectionCard.schema.simpleCardsListSectionCard,
    labeledCallToAction.schema.labeledCallToAction
]);
var validator = z.object({
    title: z.string(),
    description: simpleBlockContent.validator,
    rows: z.array(simpleCardsListSectionCard.validator.merge(arrayEntry.validator))
}).partial();
schema.simpleCardsListSection;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=simpleCardsListSection.js.map